import type { ProductType } from '@/types'
import {
  CarsFill,
  CarsOutline,
  CriusesFill,
  CriusesOutline,
  FlightsFill,
  FlightsOutline,
  HotelsFill,
  HotelsOutline,
  PackagesFill,
  PackagesOutline,
  PennySparkle,
} from '@pcln/brand'

type ProductIconType = {
  name: ProductType
  isActive: boolean
  size: string | number
}

const icons = {
  hotels: { outline: HotelsOutline, fill: HotelsFill },
  flights: { outline: FlightsOutline, fill: FlightsFill },
  vacations: { outline: PackagesOutline, fill: PackagesFill },
  cars: { outline: CarsOutline, fill: CarsFill },
  cruises: { outline: CriusesOutline, fill: CriusesFill },
  ai_mode: { outline: PennySparkle, fill: PennySparkle },
} as const

function ProductIcon(props: ProductIconType) {
  const { name, isActive, ...iconProps } = props
  const IconType = isActive ? icons[name].fill : icons[name].outline
  return <IconType {...iconProps} />
}

export default ProductIcon
